<div class="mainpanel">
    <div *ngIf="ViewReady && CurrentNominee == null">Could not find nominee. Please make sure to nominate a nominee first.</div>
    <div *ngIf="ViewReady && CurrentWindow == null">The window for making RSVPs is currently not open.</div>
    <div *ngIf="ViewReady">
        <h1>Awards Banquet RSVP</h1>
        <p>
            Please select whether or not the honoree will attend the awards banquet and click the 'Add Guest' button to add guests. 
            In addition to your honoree, each school is eligible to receive {{MaxNumberOfGuests}} complimentary tickets to the awards banquet. 
            <span class="highlight">Remember to click the 'Save/Update' button at the bottom of the screen to save your RSVPs.</span>
        </p>

        <form [formGroup]="rsvpForm" (ngSubmit)="submitRSVP(rsvpForm)" novalidate>
            <div class="verticalMargin">
                <label>Will your honoree attend the awards banquet?</label>
                <mat-radio-group formControlName="NomineeAttendance" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </div>

            <p>Please provide the name and contact information for each guest who will attend. <span class="highlight">Do <strong>NOT</strong> include the honoree in this list.</span></p>

            <button type="button" mat-raised-button color="primary" (click)="addGuest(save, null)" [disabled]="GuestArray.length >= MaxNumberOfGuests">Add Guest</button>

            <div formArrayName="GuestList">
                <mat-card [formGroupName]="i" *ngFor="let guest of GuestArray.controls; let i = index;" class="verticalMargin">
                    <h2>Guest {{guest.get('GuestNumber').value}}</h2>
                    
                    <div formArrayName="QuestionList">
                        <div [formGroupName]="j" *ngFor="let question of guest.get('QuestionList').controls; let j = index;">
                            <h2 *ngIf="question?.get('NarrativeText')?.value" [innerHTML]="question?.get('NarrativeText')?.value"></h2>
							<ng-container [ngSwitch]="question?.get('QuestionType')?.value">
								<div *ngSwitchCase="'ShortResponse'" fxLayout="column">
									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
										<div>
											<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('SortOrder')?.value}}.</span>
											<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
										</div>
										<mat-form-field appearance="outline" fxFlex="25">
											<input type="text" matInput formControlName="Response" placeholder="Type here..." />
											<mat-hint *ngIf="question?.get('DigitOnly')?.value" [style.color]="question?.get('ResponseInvalid')?.value ? 'red' : 'black'">Numbers Only</mat-hint>
										</mat-form-field>
									</div>
								</div>
								<div *ngSwitchCase="'LongResponse'" class="margin-top">
									<div>
										<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('SortOrder')?.value}}.</span>
										<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
									</div>
									<mat-form-field appearance="outline" class="fullwidth margin-top" [class.overLimit]="(question?.get('TextLimit')?.value != null && (question?.get('TextSizeCount')?.value || 0) > question?.get('TextLimit')?.value)">
										<textarea matInput formControlName="Response" placeholder="Type here..." rows="7"></textarea>
										<mat-hint *ngIf="question?.get('TextLimit')?.value != null && question?.get('LowerTextLimit')?.value != null" [style.color]="question?.get('TextSizeCount')?.value > question?.get('TextLimit')?.value || question?.get('TextSizeCount')?.value < question?.get('LowerTextLimit')?.value ? 'black' : 'limegreen'">Must be between {{question?.get('LowerTextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} and {{question?.get('TextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
										<mat-hint *ngIf="question?.get('TextLimit')?.value != null && question?.get('LowerTextLimit')?.value == null" [style.color]="question?.get('TextSizeCount')?.value > question?.get('TextLimit')?.value ? 'red' : 'black'">Limit: {{question?.get('TextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
										<mat-hint *ngIf="question?.get('TextLimit')?.value == null && question?.get('LowerTextLimit')?.value != null" [style.color]="question?.get('TextSizeCount')?.value < question?.get('LowerTextLimit')?.value ? 'black' : 'limegreen'">Must be more than {{question?.get('LowerTextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
									</mat-form-field>
								</div>
								<div *ngSwitchCase="'YesNo'" fxLayout="row" fxLayoutAlign="start center" class="margin-top">
									<mat-radio-group formControlName="Response" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
										<mat-radio-button [value]="'true'" color="primary">Yes</mat-radio-button>
										<mat-radio-button [value]="'false'">No</mat-radio-button>
									</mat-radio-group>
									<div fxFlex class="margin-left-double">
										<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('SortOrder')?.value}}.</span>
										<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
									</div>
								</div>
								<div *ngSwitchCase="'SingleCheckbox'" fxLayout="row" fxLayoutAlign="start center" class="margin-top">
									<mat-checkbox formControlName="Response" (change)="UpdateCheckbox($event, question)">
										<div>
											<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('SortOrder')?.value}}.</span>
											<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
										</div>
									</mat-checkbox>
								</div>
								<div *ngSwitchCase="'SelectionList'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
									<div fxLayoutGap="15px">
										<span *ngIf="question?.get('ShowNumber').value">{{question?.get('SortOrder')?.value}}</span>
										<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
									</div>
									<mat-form-field appearance="outline" fxFlex="25">
										<mat-select formControlName="Response" placeholder="Select here...">
											<mat-option [value]="null">Select here...</mat-option>
											<mat-option *ngFor="let qOption of question?.get('Options')?.value" [value]="qOption.Value">{{qOption.DisplayText}}</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline" fxFlex="25" *ngIf="question?.get('OtherSelected').value">
										<input type="text" matInput formControlName="OtherResponse" placeholder="Type custom response here..." />
									</mat-form-field>
								</div>
								<div *ngSwitchCase="'MultiSelectionList'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
									<div fxLayoutGap="15px">
										<span *ngIf="question?.get('ShowNumber').value">{{question?.get('SortOrder')?.value}}</span>
										<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
									</div>
									<mat-form-field appearance="outline" fxFlex="25">
										<mat-select multiple formControlName="Response" placeholder="Select here...">
											<mat-option [value]="null">Select here...</mat-option>
											<mat-option *ngFor="let qOption of question?.get('Options')?.value" [value]="qOption.Value">{{qOption.DisplayText}}</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline" fxFlex="25" *ngIf="question?.get('OtherSelected').value">
										<input type="text" matInput formControlName="OtherResponse" placeholder="Type custom response here..." />
									</mat-form-field>
								</div>
								<div *ngSwitchCase="'DatePicker'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
									<div>
										<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
										<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
									</div>
									<mat-form-field appearance="outline" class="margin-top">
										<input matInput [matDatepicker]="j" formControlName="Response" readonly />
										<mat-datepicker-toggle matSuffix [for]="j"></mat-datepicker-toggle>
										<mat-datepicker #j disabled="false"></mat-datepicker>
									</mat-form-field>
								</div>
							</ng-container>
                        </div>
                    </div>

                    <div>
                        <button type="button" mat-raised-button color="warn" (click)="removeGuest(i)">Remove Guest</button>
                    </div>
                </mat-card>
            </div>
            <div class="verticalMargin" #save>
                <p class="red" *ngIf="!ValidForm">There were one or more issues with your submission. Please scroll up to fix any fields and submit again.</p>
                <button type="button" *ngIf="!ChangesDetected" mat-raised-button color="accent">
                    <mat-icon>cloud_done</mat-icon>
                    <span>Up to date</span>
                </button>
                <button type="submit" *ngIf="ChangesDetected" mat-raised-button color="warn">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Save/Update</span>
                </button>
            </div>
        </form>
    </div>
</div>


